import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify'; // Importa react-toastify
import 'react-toastify/dist/ReactToastify.css'; // Asegúrate de importar el CSS de react-toastify
import CertificadoCompleto from './CertificadoCompleto';

const API_URL = process.env.REACT_APP_API_URL;

const RecetasDelPaciente = ({ paciente, recargar }) => {
  const [recetas, setRecetas] = useState([]);
  const [recetaSeleccionada, setRecetaSeleccionada] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!paciente?._id) return;

    setLoading(true); // Inicia la carga de recetas

    fetch(`${API_URL}/api/recetas/paciente/${paciente._id}`)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar recetas');
        return res.json();
      })
      .then(data => {
        setRecetas(data);
        setLoading(false); // Finaliza la carga de recetas
      })
      .catch(() => {
        setLoading(false);
        toast.error('Error al cargar recetas'); // Usamos toast para mejor experiencia
      });
  }, [paciente, recargar]);

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Recetas del paciente</h2>

      {/* Cargando... */}
      {loading && <p className="text-gray-500">Cargando recetas...</p>}

      {recetas.length === 0 && !loading ? (
        <p className="text-gray-500">No hay recetas registradas.</p>
      ) : (
        recetas.map((receta) => {
          const fechaCreacion = new Date(receta.fecha).toLocaleDateString('es-CL');
          const isVisible = recetaSeleccionada === receta._id; // Simplificamos la condición

          return (
            <div key={receta._id} className="mb-6 border p-4 rounded shadow-sm">
              <div className="flex justify-between items-center">
                <p className="text-sm text-gray-700">
                  Receta creada el <strong>{fechaCreacion}</strong>
                </p>
                <div className="space-x-2">
                  <button
                    onClick={() =>
                      setRecetaSeleccionada(isVisible ? null : receta._id)
                    }
                    className="bg-gray-600 text-white px-3 py-1 rounded hover:bg-gray-700 text-sm"
                  >
                    {isVisible ? 'Ocultar' : 'Ver Receta'}
                  </button>
                </div>
              </div>

              {isVisible && (
                <div className="mt-4">
                  <CertificadoCompleto receta={receta} paciente={paciente} />
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default RecetasDelPaciente;